(function () {
  if (window.__badmonAjaxCartInitialized) return;
  window.__badmonAjaxCartInitialized = true;

  const CART_CONTAINER_SELECTOR = "#CartPageContent";
  const CART_FORM_SELECTOR = "[data-ajax-cart-form]";

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, "text/html");
  }

  function updateCartCount(cart) {
    const countElements = document.querySelectorAll("#cart-count, .cart-count");
    countElements.forEach(function (element) {
      element.textContent = cart.item_count;
    });

    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
  }

  async function fetchCartPageHTML() {
    const response = await fetch(window.location.pathname, {
      method: "GET",
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" }
    });

    if (!response.ok) throw new Error("Failed to reload cart page HTML.");

    return response.text();
  }

  function replaceCartContent(html) {
    const doc = parseHTML(html);
    const currentContainer = document.querySelector(CART_CONTAINER_SELECTOR);
    const newContainer = doc.querySelector(CART_CONTAINER_SELECTOR);

    if (!currentContainer || !newContainer) throw new Error("Cart container not found.");

    currentContainer.innerHTML = newContainer.innerHTML;
  }

  async function submitCartUpdate(form) {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      body: new FormData(form),
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    if (!response.ok) throw new Error("Cart update failed.");

    const cart = await response.json();
    updateCartCount(cart);

    const html = await fetchCartPageHTML();
    replaceCartContent(html);

    document.dispatchEvent(new CustomEvent("badmon:page:loaded"));
  }

  function bindAjaxCart() {
    const form = document.querySelector(CART_FORM_SELECTOR);
    if (!form || form.dataset.ajaxCartBound === "true") return;

    form.dataset.ajaxCartBound = "true";

    form.addEventListener("submit", async function (event) {
      if (event.submitter && event.submitter.name === "checkout") return;

      event.preventDefault();
      form.classList.add("is-updating");

      try {
        await submitCartUpdate(form);
      } catch (error) {
        console.warn("AJAX cart update failed, falling back to normal submit.", error);
        form.submit();
      } finally {
        form.classList.remove("is-updating");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", bindAjaxCart);
  document.addEventListener("badmon:page:loaded", bindAjaxCart);
})();
